export default __webpack_public_path__ + "static/media/worker.fa126d64.svg";